import { useNavigate } from "@tanstack/react-router";
import { getControlName } from "@theprelude/core";
import { PartnerInboxes } from "@theprelude/sdk";
import { useMemo } from "react";
import { z } from "zod";
import { Filter } from "@/lib/filter";
import { DefaultOverlay } from "../../default-overlay";
import { InboxesTable } from "../endpoint-tables/inboxes-table";
import { buildViewSchema, getView, ViewDefinition } from "./schema";
import { InboxesView } from "./views";

const overlay = "inboxes";
const defaultFilters: never[] = [];

export const inboxesSchema = buildViewSchema({
  overlay,
  views: InboxesView,
  default: InboxesView.ALL,
});

export type InboxesSchema = NonNullable<z.infer<typeof inboxesSchema>[1]>;

export function InboxesOverlay({
  view = InboxesView.ALL,
  filters = defaultFilters,
  control,
  instanceId,
}: InboxesSchema) {
  const navigate = useNavigate();

  const onFilter = (filters: Filter[]) =>
    navigate({
      to: window.location.pathname,
      params: (prev) => prev,
      search: (prev) => ({
        ...prev,
        overlay: [overlay, { filters }],
      }),
    });

  const { title, description, query } = useMemo(
    () => getView(views, view, control),
    [control, view],
  );

  return (
    <DefaultOverlay title={title}>
      <div className="h-full overflow-hidden p-4 pb-0">
        {description && <div>{description}</div>}
        <InboxesTable
          query={query}
          filters={filters}
          control={control}
          instanceId={instanceId}
          onFilter={onFilter}
        />
      </div>
    </DefaultOverlay>
  );
}

const views: Record<InboxesView, ViewDefinition<PartnerInboxes>> = {
  [InboxesView.ALL]: {
    title: (control) =>
      control ? `${getControlName(control)} Inboxes` : "All Inboxes",
    query: {},
  },
};
